import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { DirectivesModule, MaterialModule } from '@huge-monorepo/shared/modules';
import { GenericService } from '@huge-monorepo/hip/services';
import { ToolsModule } from '@huge-monorepo/hip/tools';
import { ToastrService } from 'ngx-toastr';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService } from '@huge-monorepo/shared/interfaces';

interface DeviceTagInfo {
  DeviceNum: string;
  TagName: string;
}

@Component({
  selector: 'huge-monorepo-teltonika-update-device-tags-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule],
  templateUrl: './teltonika-update-device-tags-modal.component.html',
  styleUrl: './teltonika-update-device-tags-modal.component.scss',
})
export class TeltonikaUpdateDeviceTagsModalComponent {
  files: FileList | null;
  working: boolean = false;
  isFileUploaded: boolean = false;
  loading: boolean = false;
  devicesUpdated: DeviceTagInfo[] = [];
  devicesFailed: DeviceTagInfo[] = [];
  showLists: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TeltonikaUpdateDeviceTagsModalComponent>,
    private db: GenericService,
    private toastr: ToastrService,
    private teltonikaService: SharedTeltonikaSingletonService<IHIPTeltonikaService>,
  ) { }

  close() {
    this.dialogRef.close(null);
  }

  update() {
    if (this.files == null) {
      this.db.createToast('Error', 'Please upload a file', 'error');
      return;
    }
    this.loading = true;
    // this.dialogRef.close({ files: this.files });

    if (this.files != null) {
      this.teltonikaService.service.updateDeviceTags({ files: this.files }).subscribe({
        next: (resp) => {
          if (!resp) {
            this.toastr.error('Error Updating Device Tags');
            this.loading = false;
            this.dialogRef.close();
          } else {
            this.toastr.success('Updated Device Tags');
            console.log(resp);
            this.devicesUpdated = resp.DevicesUpdated;
            this.devicesFailed = resp.DevicesFailed;
            this.loading = false;
            this.showLists = true;
          }
        },
        error: (err) => {
          this.toastr.error('Error Updating Device');
        },
      });
    }
  }

  handleDroppedFiles(files) {
    console.log('In handleDroppedFiles');
    console.log(files);
    let input = document.getElementById('fileInput') as HTMLInputElement;
    console.log(input);
    if (input != null) {
      this.onFileInput(files);
    }
  }

  onFileInput(files: FileList) {
    console.log('In onFileInput');
    if (this.working) {
      this.db.createToast('Busy Uploading', 'You cannot change the file list whilst uploading. Please wait for the current process to finish', 'error');
      return;
    }

    if (files.length === 1) {
      console.log('One file is selected');
      if (files[0].name && !files[0].name.endsWith('.csv')) {
        this.db.createToast('Error', 'File must be CSV', 'error');
        return;
      }
      this.files = files;
      this.isFileUploaded = true;
      return;
    } else {
      this.db.createToast('Error', 'Please select only one file', 'error');
      return;
    }
  }

  deleteFile() {
    this.files = null;
    this.isFileUploaded = false;
  }

  downloadTemplate() {
    this.teltonikaService.getService().downloadUpdateTeltonikaTagTemplate().subscribe({});
  }
}
